import {Button} from 'reactstrap';
import './styles.css';
import {useNavigate} from 'react-router-dom';

import {SCAN_ARTIFACTS_PATH} from 'src/routes';

export const WizardComplete = () => {
  const navigate = useNavigate();
  return (
    <div className='WelcomeWizard'>
      <div className='WelcomeWizard__container'>
        <h2>CodeLogic is Ready!</h2>
        <p>
          You have successfully configured CodeLogic.
        </p>
        <p>
          You can now scan artifacts, databases and generate Docker commands to scan items on remote systems.
        </p>
        <p>
          To close the wizard and start scanning, click Finish.
        </p>
      </div>
      <Button className='WelcomeWizard__continue-button' color='primary' onClick={() => navigate(SCAN_ARTIFACTS_PATH)}>Finish</Button>
    </div>
  );
};
